/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DashboardServiceabilityAPI
 * @hideconstructor
 * @classdesc Internal API class that is used to manage the serviceability view.
 */
define([], () => {
	class PropertiesPaneDOMAPI {
		/**
		 * @function PropertiesPaneDOMAPI#render
		 * @description returns the view to be rendered
		 */
		render() {}

		/**
		 * @function PropertiesPaneDOMAPI#getPropertiesView
		 * @description creates the property element to render and returns it
		 * @param {boolean} options.isChild determines whether to render a child element or parent element
		 * @param {boolean} options.refreshChild determines whether to refresh a child element or create a new child element
		 * @param {Object} options.data.contentIds an array containing the content id's to get the property element for
		 * @return {boolean} returns the dom node containing the property for the provided content
		 */
		getPropertiesView() {}

		/**
		 * @function PropertiesPaneDOMAPI#getProviderId
		 * @description Returns the provider id for the feature
		 * @return {String} DOM feature provider id
		 */
		getProviderId() {}

		/**
		 * @function PropertiesPaneDOMAPI#getNode
		 * @description Returns the parent node of the properties pane
		 * @return {Node} a DOM node which represents the parent node of the properties pane
		 */
		getRenderNode() {}

		/**
		 * @function PropertiesPaneDOMAPI#close
		 * @description clean up the DOM node which represents this properties pane
		 */
		close() {}
	}

	return PropertiesPaneDOMAPI;
});